var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabelleDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tabelle_Default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B3CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    className: "st0",
    width: 40,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    className: "st0",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    className: "st0",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    className: "st0",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 28,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    className: "st1",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 37,
    className: "st0",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    className: "st0",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    className: "st0",
    width: 12,
    height: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabelleDefault);
export default __webpack_public_path__ + "static/media/tabelle-default.b4add9de77d33ff0eb8cadfd05af240a.svg";
export { ForwardRef as ReactComponent };